export default {
  d: "M47,94C21.084,94,0,72.916,0,47S21.084,0,47,0s47,21.084,47,47S72.916,94,47,94z M47,12.186\r\n\t\t\tc-19.196,0-34.814,15.618-34.814,34.814c0,19.195,15.618,34.814,34.814,34.814c19.195,0,34.814-15.619,34.814-34.814\r\n\t\t\tC81.814,27.804,66.195,12.186,47,12.186z",
  viewBox: "0 0 94 94"
}
